module.exports = __webpack_public_path__ + "img/banner1.0260b754.png";